import { UserButton, useClerk } from "@clerk/clerk-react";
import { useSearchParams } from "react-router-dom";

import { RedirectExternButton } from "@/components/RedirectExternButton";

import Page from "../components/Page";

export default function SignedInPage(): JSX.Element | null {
  const { session } = useClerk();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect_url");
  if (redirectUrl) {
    window.location.href = redirectUrl;
    return null;
  }

  return (
    <Page>
      <UserButton />
      <p className="mt-3 text-lg leading-none tracking-tighter text-gray-700 lg:text-lg">Willkommen</p>
      <p className="text-xl font-semibold leading-none tracking-tighter text-black lg:text-xl">
        {session?.user.fullName ?? session?.user.emailAddresses[0].emailAddress}
      </p>
      <p className="mt-4 text-center text-sm leading-relaxed text-gray-700">
        Wählen Sie Ihre gewünschte Applikation aus.
      </p>
      <div className="mt-4 w-full">
        <RedirectExternButton redirectUrl={import.meta.env.VITE_DVAG_CUSTOMER_PORTAL_URL} text="Nutzerportal" />
      </div>
    </Page>
  );
}
